import { ReactElement } from 'react';
import { Message, useMessage } from '@messageformat/react';
import { IconInformation } from '@op/opds.opux-icons/indicator';
import { space } from '@op/opds.tokens';
import CourseTaskHeader from '../CourseTaskHeader';
import InvestmentProduct from './TaskOne/InvestmentProduct';
import parseMsgContent from '../../util/parseMsgContent';
import CourseContent from '../CourseContent';

const TaskOne = (): ReactElement => {
  const taskIntro = useMessage('course9.task1.intro');
  const parsedTask = parseMsgContent(taskIntro);
  return (
    <div>
      <CourseTaskHeader questionNumber={1} totalQuestions={1} />
      <CourseContent content={parsedTask} />
      <div
        className="investoracademy-vertical-flex-align"
        style={{ flexDirection: 'column' }}
      >
        <InvestmentProduct />
        <p
          className="opds-styles-v1-text-label-small"
          style={{ display: 'flex', paddingBottom: space.default }}
        >
          <IconInformation />
          <Message id="course9.task1.note" />
        </p>
      </div>
    </div>
  );
};

export default TaskOne;
